import { config } from "../config/config";
import { getAuthToken } from "./tokenService.service";

export const podService = {
  weeklyPodOSProgress: async (branchId: string) => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/pod/weekly-progress`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ branch_id: branchId }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch pod weekly progress");
    }

    const json = await response.json();
    return json.data;
  },

  monthlyPodOSProgress: async (branchId: string) => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/pod/monthly-progress`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ branch_id: branchId }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch pod monthly progress");
    }

    const json = await response.json();
    return json.data;
  },
};
